import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { updateVilansKickTile, VilansKickAppDetailsTileModel } from "client/Api/Workspace/workspace";

export type EditVilansKickTileProps = EditGenericWithDestinationWindowTilePropsBase<VilansKickAppDetailsTileModel>;

export const EditVilansKickTile = forwardRef(
	(props: EditVilansKickTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateVilansKickTile}
				ref={ref}
			/>
		);
	}
);
EditVilansKickTile.displayName = "EditVilansKickTile";
